import React from "react";
import FeatherIcon from "feather-icons-react";
import * as style from "../styles.module.scss";

const KID = ({ onClick }) => {
  return (
    <div className={style.downloadContainer} id="profileKIDSection">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <FeatherIcon
          icon="download-cloud"
          size={30}
          style={{
            minWidth: "fit-content",
            color: "#A1ADBF",
            marginRight: "12px",
          }}
        />
        <h2 className={style.profile__admin_downloadtitle}>
          Key Information Document
        </h2>
      </div>
      <span className="d-flex align-items-end">
        <button
          className={`btn btn-outline-info text-dark ${style.profile__job_button}`}
          onClick={onClick}
        >
          Download document
        </button>
      </span>
    </div>
  );
};

export default KID;
